import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/api/login',
    method: 'post',
    data: {
      username:username,
      password:password
    }
  })
}

export function getInfo() {
  return request({
    url: '/api/merchantInfo',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/api/logout',
    method: 'get'
  })
}

export function uploadImg(params) {
  return request({
    url: '/api/modifyInfo',
    method: 'POST',
    params: params,

  })
}







// WEBPACK FOOTER //
// ./src/api/login.js